/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missed_ItInputs */

const en_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cake baked`)
};

const ar_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم خبز أي كعكة`)
};

const de_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Kuchen gebacken`)
};

const es_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se horneó ningún pastel`)
};

const fr_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun gâteau cuit`)
};

const it_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna torta preparata`)
};

const ja_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキは焼かれませんでした`)
};

const ko_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구운 케이크 없음`)
};

const pt_br_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum bolo assado`)
};

const ru_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпечка не завершена`)
};

const th_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ได้อบเค้ก`)
};

const tr_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta pişirilmedi`)
};

const zh_cn_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完成烘焙`)
};

const zh_tw_missed_it = /** @type {(inputs: Missed_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未完成烘焙`)
};

/**
* | output |
* | --- |
* | "No cake baked" |
*
* @param {Missed_ItInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const missed_it = /** @type {((inputs?: Missed_ItInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missed_ItInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_missed_it(inputs)
	if (locale === "ar") return ar_missed_it(inputs)
	if (locale === "de") return de_missed_it(inputs)
	if (locale === "es") return es_missed_it(inputs)
	if (locale === "fr") return fr_missed_it(inputs)
	if (locale === "it") return it_missed_it(inputs)
	if (locale === "ja") return ja_missed_it(inputs)
	if (locale === "ko") return ko_missed_it(inputs)
	if (locale === "pt_br") return pt_br_missed_it(inputs)
	if (locale === "ru") return ru_missed_it(inputs)
	if (locale === "th") return th_missed_it(inputs)
	if (locale === "tr") return tr_missed_it(inputs)
	if (locale === "zh_cn") return zh_cn_missed_it(inputs)
	return zh_tw_missed_it(inputs)
});